<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId" [modalHelpIndex]="modalHelpIndex"
  [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
  (primaryButtonActionEmt)="exportProject()" (closeButtonActionEmt)="closeModal()"
  [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
  [(isBusyMessage)]="isBusyMessage" [resizeHorizontal]="true" [resizeHorizontalMin]="400" [resizeVertical]="true"
  [resizeVerticalMin]="400" [maximizable]="true">
  <form>
    <div class="modal-row">
      <div class="modal-row-column-auto group-label">
        <label for="name" requiredAsterisk>Source Files: </label>
      </div>
      <div class="modal-row-column-max vertical-middle">
        <res-custom-radio-button [automationId]="modalAutomationId + '-include-files'" [(ngModel)]="sourceFiles"
          content="Include Files" name="source-files" value="include-files" checked="checked"></res-custom-radio-button>
      </div>
    </div>
    <div class="modal-row no-top-padding">
      <div class="modal-row-column-auto group-label"></div>
      <div class="modal-row-column-max description">
        <res-custom-radio-button [automationId]="modalAutomationId + '-connector'" [(ngModel)]="sourceFiles"
          content="Connector References Only" name="source-files" value="connector-references-only">
        </res-custom-radio-button>
      </div>
    </div>
  </form>

  <res-data-area-and-tree class="modal-fill" [automationId]="modalAutomationId"
    (onDAATChange)="onDataAreaAndTreeChange()"></res-data-area-and-tree>

  <form>
    <div class="modal-row path-area">
      <div class="modal-row-column-auto">
        <label for="selected-path">Path: </label>
      </div>
      <div class="modal-row-column-max">
        <input type="text" id="selected-path" [(ngModel)]="selectedPath"
          [title]="!dataAreaAndTreeComponent.selectedDataArea ? 'Please select a Data Area' : ''"
          [attr.data-automation-id]="modalAutomationId + '-path-input'" (ngModelChange)="clearPathTreeSelection()"
          name="selected-path" value="" [disabled]="!dataAreaAndTreeComponent.selectedDataArea" />
      </div>
    </div>
  </form>
</res-base-modal>